import { SharedModule } from "./shared.module";
import { InterceptorService } from "./shared/interceptor/interceptor.service";
import { HeaderBodyFooterAdderComponent } from "./theme/header-body-footer-adder/header-body-footer-adder.component";
import { PageNotFoundComponent } from "./page-not-found/page-not-found.component";
import { CommonModule } from "@angular/common";
import { BrowserModule, Title } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {
  NgModule,
  Injectable,
  ErrorHandler,
  CUSTOM_ELEMENTS_SCHEMA,
} from "@angular/core";
import { JwtModule } from "@auth0/angular-jwt";
import { CookieService } from "ngx-cookie-service";
// import * as Sentry from '@sentry/browser';
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgSelectModule } from "@ng-select/ng-select";
import { RouterModule } from "@angular/router";

import { provideNgxMask } from "ngx-mask";
import { NgProgressModule } from "ngx-progressbar";
import { HttpErrorComponent } from "./static-pages/http-error/http-error.component";
import { HttpComponent } from "./static-pages/http/http.component";
import { directLiginComponent } from "./static-pages/direct-login/direct-login.component";
import { NgbDatepickerI18n } from "@ng-bootstrap/ng-bootstrap";
import { CustomDatepickerI18n } from "./shared/i18n/custom-datepicker-i18n.service";
import { AccessibilityBarComponent } from "./shared/components/accessibility-bar/accessibility-bar.component";

export function tokenGetter() {
  return localStorage.getItem("access_token");
}
// Sentry.init({
//   dsn: environment.sentry_dsn
// });

// @Injectable()
// export class SentryErrorHandler implements ErrorHandler {
//   constructor() {}
//   handleError(error) {
//     Sentry.captureException(error.originalError || error);
//     throw error;
//   }
// }

@NgModule({
  declarations: [
    AppComponent,
    HeaderBodyFooterAdderComponent,
    PageNotFoundComponent,
    HttpErrorComponent,
    HttpComponent,
    directLiginComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    CommonModule,
    BrowserModule,
    NgSelectModule,
    BrowserAnimationsModule,
    SharedModule,
    RouterModule,
    AppRoutingModule,
    RouterModule,
    NgProgressModule,
    AccessibilityBarComponent,

    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        allowedDomains: ["http://dev-api.apprenticeshipindia.org"],
        disallowedRoutes: ["http://dev-api.apprenticeshipindia.org"],
      },
    }),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n
    },
    Title,
    //  { provide: ErrorHandler, useClass: SentryErrorHandler },
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
    CookieService,

    provideHttpClient(withInterceptorsFromDi()),
    provideNgxMask(),
  ],
})
export class AppModule {}
